import React, { useState } from "react"
import { ReactFC } from "types"

export interface ScreenContextType {
    minimized: boolean
    setMinimized: React.Dispatch<React.SetStateAction<boolean>>
    drawerOpen: boolean
    setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const ScreenContextProvider: ReactFC = ({
    children
}) => {
    const [minimized, setMinimized] = useState<boolean>(true)
    const [drawerOpen, setDrawerOpen] = useState<boolean>()    
    return (
        <ScreenContext.Provider value={{ minimized, setMinimized, drawerOpen, setDrawerOpen }}>
            {children}
        </ScreenContext.Provider>
    )
}

export const ScreenContext = React.createContext<ScreenContextType>({ 
    minimized: false,
    setMinimized: () => null,
    drawerOpen: false,
    setDrawerOpen: () => null,
})
